module.exports = __webpack_public_path__ + "static/media/ttslogo.14ee4cd7.png";